export const siteSettings = {
  name: "Nadex Pro",
  link: "https://nadexpro.com",
  email: "support@nadexpro.com",
  appLink: "https://app.nadexpro.com",
};
